import { useTranslation } from 'next-i18next';
import { type AiLoadingState } from './aiLoadingMessages.const';
import { AiGeneratingPending } from './Base';
type Props = {
  file?: File;
  loadingState: Omit<AiLoadingState, 'sourceType'>;
};
export const AiGeneratingPendingByFile = ({
  file,
  loadingState
}: Props) => {
  const {
    t
  } = useTranslation(['build']);
  return <AiGeneratingPending imageSrc={'/assets/ai_generating_v2.webp'} prompt={file?.name ? t('build:ai.file.generatingByFile', {
    fileName: file.name
  }) : undefined} loadingState={{
    ...loadingState,
    sourceType: 'file'
  }} data-sentry-element="AiGeneratingPending" data-sentry-component="AiGeneratingPendingByFile" data-sentry-source-file="AiGeneratingPendingByFile.tsx" />;
};